<template>
  <v-app>
    <template v-if="alert">
      <alert-component :alert="alert"/>
    </template>
    <app-bar-component/>
    <v-main>
      <transition mode="out-in"
                  enter-active-class="transition-ease-in-out"
                  leave-active-class="transition-ease-in-out">
        <router-view/>
      </transition>
    </v-main>
    <v-navigation-drawer
      v-model="show"
      width="310"
      right
      dark
      fixed
      temporary>
      <sidenav-component/>
    </v-navigation-drawer>
    <template v-if="dialog">
      <modal-component :dialog="dialog"/>
    </template>
    <add-new-subscriber-dialog />
    <update-subscriber-dialog />
  </v-app>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {

    }
  },
  computed: {
    show: {
      get () {
        return this.$store.getters.GET_DRAWER
      },
      set (value) {
        this.$store.dispatch('setDrawer', value)
      }
    },
    dialog () {
      return this.$store.getters.GET_DIALOG
    },
    alert () {
      return this.$store.getters.GET_ALERT
    }
  }
}
</script>
